import { render, staticRenderFns } from "./GoogleImport.vue?vue&type=template&id=460c94cc&scoped=true"
import script from "./GoogleImport.vue?vue&type=script&lang=js"
export * from "./GoogleImport.vue?vue&type=script&lang=js"
import style0 from "./GoogleImport.vue?vue&type=style&index=0&id=460c94cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460c94cc",
  null
  
)

export default component.exports